// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"b84ebb9e","47":"be9e9b02","343":"ce9bded0","493":"9712c2db","927":"b6e7c53e"}[chunkId] + ".chunk.css";
};